/**
 * Determine if a given node is a line
 */
export function isTouchEvent(event: MouseEvent | PointerEvent | TouchEvent): event is TouchEvent {
  return (<TouchEvent>event).touches !== undefined;
}
